class MemberGateGuard extends HTMLElement {
  constructor() {
    super();
    this.cookieName = this.dataset.cookieName || 'rc_member_id';
    this.dialog = this.querySelector('.member-gate__dialog');
  }

  connectedCallback() {
    const memberId = this.getMemberIdFromCookie() || this.getMemberIdFromUrl();

    if (memberId) {
      this.rememberMemberId(memberId);
      return;
    }

    this.deny();
  }

  isValidFormat(value) {
    return /^[a-zA-Z0-9]{8}$/.test(value);
  }

  getMemberIdFromCookie() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${this.cookieName}=([^;]*)`));
    const value = match ? decodeURIComponent(match[1]) : null;
    return this.isValidFormat(value || '') ? value : null;
  }

  getMemberIdFromUrl() {
    const value = new URLSearchParams(window.location.search).get('member_id');
    return this.isValidFormat(value || '') ? value : null;
  }

  rememberMemberId(memberId) {
    const oneYearInSeconds = 60 * 60 * 24 * 365;
    document.cookie = `${this.cookieName}=${memberId}; max-age=${oneYearInSeconds}; path=/; SameSite=Lax`;
  }

  deny() {
    this.hidden = false;
    document.body.classList.add('overflow-hidden');
    trapFocus(this.dialog);
  }
}

customElements.define('member-gate-guard', MemberGateGuard);
